import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["limitsData"];
import { createContext, useContext, useMemo } from 'react';
import useFetchContentUsageLimits from '../hooks/useFetchContentUsageLimits';
import { jsx as _jsx } from "react/jsx-runtime";
export const ContentUsageLimitsContext = /*#__PURE__*/createContext(undefined);
export const ContentUsageLimitsProvider = ({
  children,
  limitNameToLimitTypeMap,
  shouldFetchUsageLimits = false,
  contentObjectType,
  contentGroupObjectType
}) => {
  const _useFetchContentUsage = useFetchContentUsageLimits({
      limitNameToLimitTypeMap,
      shouldFetchUsageLimits,
      contentObjectType,
      contentGroupObjectType
    }),
    {
      limitsData: contentUsageLimits
    } = _useFetchContentUsage,
    rest = _objectWithoutPropertiesLoose(_useFetchContentUsage, _excluded);
  const value = useMemo(() => Object.assign({}, rest, {
    contentUsageLimits
  }), [contentUsageLimits, rest]);
  return /*#__PURE__*/_jsx(ContentUsageLimitsContext.Provider, {
    value: value,
    children: children
  });
};
export function useContentUsageLimitsProvider() {
  const context = useContext(ContentUsageLimitsContext);
  if (context === undefined) {
    throw new Error('useContentUsageLimitsProvider must be used within a ContentUsageLimitsProvider');
  }
  return context;
}